export const SFLAGA_IMPROVEMENT_BENCHMARK_SCHEMA_VERSION = 2;

interface BenchmarkSchemaLike {
  experiment?: {
    benchmarkCode?: string;
    benchmarkSchemaVersion?: number;
    conditionIds?: string[];
    conditionSignature?: string;
    includeSflaGaBaseline?: boolean;
    fitnessMode?: string;
    taskSpecificVariationEnabled?: boolean;
  };
  conditions?: Array<{ id: string }>;
}

export function getSflagaImprovementBenchmarkConditionIds(
  report: BenchmarkSchemaLike
): string[] {
  const conditionIds = report.experiment?.conditionIds;
  if (conditionIds && conditionIds.length > 0) {
    return [...conditionIds];
  }

  return (report.conditions ?? []).map((condition) => condition.id);
}

export function buildSflagaImprovementBenchmarkConditionSignature(
  conditionIds: string[]
): string {
  return conditionIds.join('|');
}

export function getSflagaImprovementBenchmarkConditionSignature(
  report: BenchmarkSchemaLike
): string {
  return (
    report.experiment?.conditionSignature ??
    buildSflagaImprovementBenchmarkConditionSignature(
      getSflagaImprovementBenchmarkConditionIds(report)
    )
  );
}

export function getSflagaImprovementBenchmarkCompatibilityIssue(
  currentReport: BenchmarkSchemaLike,
  comparisonReport: BenchmarkSchemaLike
): string | null {
  const currentBenchmarkCode = currentReport.experiment?.benchmarkCode ?? 'g';
  const comparisonBenchmarkCode = comparisonReport.experiment?.benchmarkCode ?? 'g';

  if (currentBenchmarkCode !== comparisonBenchmarkCode) {
    return 'Benchmark profile does not match.';
  }

  if (
    Boolean(currentReport.experiment?.includeSflaGaBaseline) !==
    Boolean(comparisonReport.experiment?.includeSflaGaBaseline)
  ) {
    return 'Baseline algorithm set does not match.';
  }

  if (
    (currentReport.experiment?.fitnessMode ?? 'energy-aware') !==
    (comparisonReport.experiment?.fitnessMode ?? 'energy-aware')
  ) {
    return 'Fitness mode does not match.';
  }

  if (
    Boolean(currentReport.experiment?.taskSpecificVariationEnabled) !==
    Boolean(comparisonReport.experiment?.taskSpecificVariationEnabled)
  ) {
    return 'Task-specific matrix variation setting does not match.';
  }

  if (
    getSflagaImprovementBenchmarkConditionSignature(currentReport) !==
    getSflagaImprovementBenchmarkConditionSignature(comparisonReport)
  ) {
    return 'Condition set does not match this benchmark version.';
  }

  return null;
}
